$(document).ready(function(){  
  $(".set > h3").on("click", function () {
    if ($(this).hasClass("active")) {
      $(this).removeClass("active");
      $(this).siblings(".content") .slideUp(200);
    } 
    else {
      $(".set > h3").closest('.accordion-container').find('.set > h3').removeClass("active");
      $(this).addClass("active");
      $(".set > h3").closest('.accordion-container').find(".content").slideUp(200);
      $(this).siblings(".content").slideDown(200);
    }
  }); 
});